import React from 'react';
import { Form, Input, Select } from 'antd';
import SectionHeader from '../../components/SectionHeader';
import InfoTip from '../../components/InfoTip';
import { TAX_ID_TYPES } from '../../constants';
import s from '../../s.module.less';
import sc from './s.module.less';

// 输入时按类型即时加分隔符展示；提交时 stepValuesToDto 会剥掉分隔符存纯数字
const formatTaxId = (raw: string, isSsn: boolean) => {
    const d = raw.replace(/\D/g, '').slice(0, 9);
    if (isSsn) {
        if (d.length <= 3) return d;
        if (d.length <= 5) return `${d.slice(0, 3)}-${d.slice(3)}`;
        return `${d.slice(0, 3)}-${d.slice(3, 5)}-${d.slice(5)}`;
    }
    if (d.length <= 2) return d;
    return `${d.slice(0, 2)}-${d.slice(2)}`;
};

// Step 2 — Tax information：EIN / SSN 类型 + 号码（占位与格式随类型变化）
export default function StepTaxInfo() {
    const form = Form.useFormInstance();
    const taxIdType = Form.useWatch(['tax', 'taxIdType'], form);
    const isSsn = taxIdType === 'ssn';

    return (
        <div className={s.wizSection} data-wiz-section>
            <SectionHeader title="Federal Tax ID" />
            <div className={s.wizRow}>
                <Form.Item name={['tax', 'taxIdType']} label="Tax ID type">
                    <Select
                        size="large"
                        placeholder="Select type"
                        options={TAX_ID_TYPES}
                        onChange={(type) => {
                            // 切换类型时按新格式重排已输入的数字
                            const current = form.getFieldValue(['tax', 'taxId']) || '';
                            form.setFieldValue(['tax', 'taxId'], formatTaxId(current, type === 'ssn'));
                        }}
                    />
                </Form.Item>
                <Form.Item
                    name={['tax', 'taxId']}
                    label={
                        <span>
                            Tax ID number
                            <InfoTip title="Format: XX-XXXXXXX. Found on your IRS determination letter or W-9." />
                        </span>
                    }
                    normalize={(v) => formatTaxId(v || '', isSsn)}
                >
                    <Input size="large" placeholder={isSsn ? 'XXX-XX-XXXX' : 'XX-XXXXXXX'} />
                </Form.Item>
            </div>
            {isSsn && (
                <p className={sc.helper}>
                    If you are a solo provider using your SSN for billing, select SSN above and enter it here instead.
                </p>
            )}
        </div>
    );
}
